import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* failureMessage({ error }) {
    const { message } = error.response;

    yield put(showNotification(message, 'warning'));
}

export default function* voucherSagas() {
    yield [
        takeEvery('VOUCHER_DOWNLOAD_FAILURE', failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/voucherSagas.js